import { createReducer, on } from "@ngrx/store";
import { erfNoAction, farmNoAction, allotmentAction, sgCodeAction } from "../actions/Property-info.actions";
//reducer is used to store values in global store -> StoreModule.forRoot({}, {}) in src/app/app.module.ts
//reducer starting state
const initialState = null;
export const piErfNoReducer = createReducer(initialState, on(erfNoAction, (state, action) => action.value));
export const piFarmNoReducer = createReducer(initialState, on(farmNoAction, (state, action) => action.value));
export const piAlotmentReducer = createReducer(initialState, on(allotmentAction, (state, action) => action.value));
export const piSGCodeReducer = createReducer(initialState, on(sgCodeAction, (state, action) => action.value));
